module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-andrea-piacquadio-3846559-small-ad9c95689eb798fa17e917864815a09f.jpg";